export default __webpack_public_path__ + "static/117-min-min-37788a3631709dda6b385deb567fdb3f.jpg";